// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"navigation-arrow"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 4L20 20L12 17.5L4 20L12 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 4L20 20L12 17.5L4 20L12 4Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-navigation-arrow')
export default class NavigationArrowIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'navigation-arrow',
    }
  }
}
